const baseClassName = 'ZendeskAesopChat';
const iframeContainerClass = `${baseClassName}-parentContainer`;
const launcherClassName = `${baseClassName}-launcher`;
const indicatorClassName = `${baseClassName}-indicator`;
const newMessageClassName = `${baseClassName}-newMessage`;
const notificationsCookieName = 'zendeskNotifications';

function isZeDefined() {
  return typeof window.zE !== 'undefined';
}

function initMessenger(zE) {
  const zendeskContainer = document.createElement('div');
  zendeskContainer.classList.add(iframeContainerClass);

  const launcher = document.createElement('button');
  launcher.innerHTML = "Live Assistance";
  launcher.classList.add(launcherClassName);
  launcher.classList.add('isMessenger');
  launcher.setAttribute('type', 'button');

  launcher.addEventListener('click', function () {
    zE('messenger', 'open');
    zE('messenger', 'show');
  });

  zendeskContainer.append(launcher);
    const widget = document.body.querySelector(
    '[data-product="web_widget"]'
  );
   widget.after(zendeskContainer);
}

function openChat() {
  if (window.zE.widget === 'classic') {
    window.zE.activate();
  } else if (window.zE.widget === 'messenger') {
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
   
  }

}

function customEventBinding(customFn) {
  document.addEventListener(
    'click',
    function (event) {
      if (event.target.matches('[href*="custom:openZendesk"]')) {
        event.preventDefault();
        customFn?.();
        return false;
      }
    },
    false
  );
}

//run it

  setTimeout(()=> {
      if (isZeDefined()) {
    window.zE(function () {
      try {
        initMessenger(window.zE);
        customEventBinding(openChat);
      } catch (e) {
        console.error(e);
      }
    });
  }

  } ,200)